import { useDependencies } from '@servicetitan/react-ioc';
import { USER_STORE_TOKEN } from '../stores/user.store';

export const useUserStore = () => {
    const [userStore] = useDependencies(USER_STORE_TOKEN);
    return userStore;
};
